<script>
import ListingModel from "@/views/Absence/AbsenceRequest/Components/ListingModel.vue";

export default {
    name: "AbsenceRequests",
    components: {ListingModel}
}
</script>

<template>
    <ListingModel :vacation="false"/>
</template>